export const getSlides = (state) => state?.slides?.slides;

export const getSlide = (state) => state?.slides?.slide;

export const getSlideType = (state) =>
  state.slides?.slide?.slideType?.[0].__component;

export const getSlidesLoading = (state) => state?.slides?.loading;

export const getSlideDuration = (state) => state?.slides?.slide?.duration;

export const getSponsors = (state) => state?.slides?.sponsors;
